import { render, staticRenderFns } from "./historicalQuotation.vue?vue&type=template&id=08f4583c&scoped=true"
import script from "./historicalQuotation.vue?vue&type=script&lang=js"
export * from "./historicalQuotation.vue?vue&type=script&lang=js"
import style0 from "./historicalQuotation.vue?vue&type=style&index=0&id=08f4583c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f4583c",
  null
  
)

export default component.exports